import { render, staticRenderFns } from "./data-subject-audit-history.vue?vue&type=template&id=8bf01a1a"
import script from "./data-subject-audit-history.vue?vue&type=script&lang=js"
export * from "./data-subject-audit-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports